import InvoiceTable from './InvoiceTable.jsx'

export default InvoiceTable
